<template>
  <div class="cp-prize" :class="level" @click="choosePrize">
    <div class="bg" :class="level">
      <div class="prize" :class="`prize-${prize} ${star}`">
        <div v-if="drawed" class="drawed"></div>
      </div>
    </div>
    <div v-if="!drawed && checked" class="checked"></div>
    <div class="name" :class="level">
      {{name}}
    </div>
  </div>
</template>

<script>
import { getParameterByName } from "~/tools/utils";
export default {
  name: 'team',
  props: {
    prize: {
      type: Number,
      default: () => 0
    },
    id: {
      type: Number,
      default: () => 0
    },
    name: {
      type: String,
      default: () => ''
    },
    drawed: {
      type: Number,
      default: 0
    },
    canDraw: {
      type: Boolean,
      default: false
    },
    choosed: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    level() {
      if(this.prize === 32) {
        return 'prize32'
      }
      if(this.prize === 31) {
        return 'prize31'
      }
      if(this.prize >= 23) {
        return 'purple'
      }
      if([4,21,22].includes(this.prize)) {
        return 'green'
      }
      if([3,6,10,12,16,19,20].includes(this.prize)) {
        return 'yellow'
      }
      return 'blue'
    }
  },
  data() {
    return {
      checked: false,
      canCheck: false,
      star: getParameterByName('star')
    }
  },
  mounted() {
    console.log(this.choosed);
    this.checked = this.choosed
  },
  watch: {
    choosed: {
      handler(value) {
        this.checked = value
      },
      immediate: true
    },
    canDraw: {
      handler(value) {
        this.canCheck = value
      },
      immediate: true
    }
  },
  methods: {
    choosePrize() {
      if(!this.canCheck && !this.checked) {
        return
      }
      this.checked = !this.checked;
      this.$emit("toggle", {
        checked: this.checked,
        id: this.id,
        icon: this.prize,
        name: this.name
      })
    }
  }
};
</script>

<style lang="stylus" scoped>
  .cp-prize {
    width 1.27rem
    height 1.8rem
    margin -0.07rem 0 0 -0.1rem
    display block
    position relative
    &.prize31 {
      width 2.47rem
      margin-left -0.16rem
    }
    &.prize32 {
      width 3.88rem
      margin-left -0.25rem
      overflow hidden
    }
    .bg {
      position absolute
      top 0
      width 1.27rem
      height 1.27rem
      background: url('./images/blue.png') no-repeat
      background-size 1.27rem 1.27rem
      &.prize31 {
        width 2.47rem
        background: url('./images/31.png') no-repeat
        background-size 2.47rem 38.1rem
        animation: auto-circle 2s steps(29) infinite;
      }
      &.prize32 {
        width 3.88rem
        background: url('./images/32.png') no-repeat
        background-size 3.88rem 38.1rem
        animation: auto-circle 2s steps(29) infinite;
      }
      &.yellow {
        background-image: url('./images/yellow.png')
        background-size 1.27rem 38.1rem
        animation: auto-circle 2s steps(29) infinite;
      }
      &.blue {
        background-image: url('./images/blue.png')
        background-size 1.27rem 38.1rem
        animation: auto-circle 2s steps(29) infinite;
      }
      &.green {
        background-image: url('./images/green.png')
        background-size 1.27rem 38.1rem
        animation: auto-circle 2s steps(29) infinite;
      }
      &.purple {
        background-image: url('./images/purple.png')
        background-size 1.27rem 38.1rem
        animation: auto-circle 2s steps(29) infinite;
      }
    }
    .name {
      position absolute
      bottom 0.07rem
      width 0.88rem
      left 0.195rem
      height 0.44rem
      font-size 0.2rem
      font-weight bold
      line-height 0.22rem
      color #a25f38
      text-align center
      &.prize31, &.prize32 {
        color: #b43d03
        width: 100%
        left: 0
        text-align center
      }
      &.yellow {
        color: #a59b2a
      }
      &.blue {
        color: #4e6b9f
      }
      &.green {
        color: #367e29;
      }
      &.purple {
        color: #9e2c86
      }
    }
    .checked {
      position absolute
      top: 0.01rem
      right 0.05rem
      width 0.37rem
      height 0.37rem
      background-image: url('./images/checked.png')
      background-size contain
      background-position center center
      background-repeat no-repeat
      animation fadeIn 0.6s ease
    }
    .prize {
      width 1.07rem
      height 1.07rem
      background-position center center
      background-repeat no-repeat
      margin 0.1rem auto
      position relative
      background-size 1.07rem 1.07rem
      .drawed {
        position absolute
        top: 0.185rem
        left 0.185rem
        width 0.7rem
        height 0.7rem
        background-image: url('./images/drawed.png')
        background-size 0.66rem 0.65rem
        background-position center center
        background-repeat no-repeat
      }
      &-1, &-2, &-3 {
        background-image: url('./images/prize/1.png')
        background-size 0.73rem 0.72rem
      }
      &-4 {
        background-image: url('./images/prize/4.png')
        background-size 0.68rem 0.75rem
        // transform: scale(1.2);
      }
      &-6, &-5 {
        background-image: url('./images/prize/6.png')
        background-size 0.8rem 0.78rem
      }
      &-9, &-10 {
        background-image: url('./images/prize/9.png')
        background-size 0.7rem 0.77rem
      }
      &-11, &-12 {
        background-image: url('./images/prize/11.png')
        background-size 0.72rem 0.62rem
      }
      &-13, &-7 {
        background-image: url('./images/prize/13.png')
        background-size 0.71rem 0.76rem
      }
      &-14, &-8 {
        background-image: url('./images/prize/14.png')
        background-size 0.7rem 0.76rem
      }
      &-15, &-16 {
        background-image: url('./images/prize/15.png')
        background-size 0.77rem 0.59rem
      }
      &-17, &-19, &-21 {
        background-image: url('./images/prize/17.png')
        background-size 0.8rem 0.72rem
      }
      &-18, &-20, &-22 {
        background-image: url('./images/prize/18.png')
        background-size 0.75rem 0.74rem
      }
      &-23 {
        background-image: url('./images/prize/23.png')
        background-size 0.82rem 0.72rem
        background-position 0.16rem center
      }
      &-24 {
        background-image: url('./images/prize/24.png')
        background-size 0.86rem 0.72rem
      }
      &-25 {
        background-image: url('./images/prize/25.png')
        background-size 0.82rem 0.76rem
      }
      &-26 {
        background-image: url('./images/prize/26.png')
        background-size 0.78rem 0.76rem
      }
      &-27 {
        background-image: url('./images/prize/27.png')
        background-size 0.81rem 0.7rem
        background-position 0.18rem center
        // transform: scale(1.2);
      }
      &-28 {
        background-image: url('./images/prize/28.png')
        background-size 1.07rem 0.53rem
      }
      &-29 {
        background-image: url('./images/prize/29.png')
        background-size 0.9rem 0.78rem
        // transform: scale(1.15);
      }
      &-30 {
        background-image: url('./images/prize/30.png')
        background-size 0.97rem 0.88rem
      }
      &-31 {
        background-image: url('./images/prize/31.png')
        background-size 1.6rem 0.88rem
        width 2.47rem
        .drawed {
          left 50%
          margin-left -0.35rem
        }
      }
      &-32 {
        background-image: url('./images/prize/32.png')
        background-size 3.03rem 0.91rem
        width 3.88rem
      }
    }
  }

  @keyframes auto-circle {
    to {
      background-position-y: -36.83rem;
    }
  }

  @keyframes fadeIn {
    from {
      opacity 0
    }
    to {
      opacity 1
    }
  }
</style>
